module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/081-bermuda-8f0fbd5d3bc979213717ab8c1e9a8e21.svg";